import React, { useContext, useEffect, useState } from "react";
import { DEFAULT_MODEL_EMPLOYEE_XLSX } from "../../../../constants/api";
import {
  createTempModel,
  getUsersJsonFromList,
  getUsersJsonFromListUpdated,
  getUsersJsonPermission,
} from "../../../../helpers/employeeHelper";
import { useNavigate } from "react-router";
import * as a from "../../../../constants/api";
import * as fa from "@fortawesome/free-solid-svg-icons";
import * as h from "../../../../helpers";
import * as r from "../../../../constants/routes";
import ButtonsArea from "../../../../components/Buttons/ButtonsArea";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import InputDragAndDrop from "../../../../components/Inputs/InputDragAndDrop";
import ListUsers from "../../../../components/Lists/ListUsers";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import pClasses from "../Users.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import SessionContext from "../../../../context/sessionContext";
import Spinner from "../../../../components/Spinner";
import Title from "../../../../components/Title";
import useFetch from "../../../../hooks/useFetch";
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

export default function UserRemove() {
  const history = useNavigate();

  const [newUsers, setNewUsers] = useState<any | null>(null);
  const [confirmTop, setConfirmTop] = useState<any | null>(null); //useState<string | null>(null);
  const [_contentBottom, setcontentBottom] = useState<any | null>(null);
  const [isListOpen, setListOpen] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { t } = useTranslation();

  const cSessions = useContext(SessionContext);

  const [, listUserIsLoading, listUserError, listUserFetch]: any = useFetch({
    // TODO show img error upload
    autoInit: false,
  });

  let routePost = "";
  const getRoutePost = (plan_permission: string) => {
    switch (plan_permission) {
      case "go":
        return (routePost = r.R_A_USERS_LIST);
      case "smart":
        return (routePost = r.R_A_USERS_LIST_SMART);
      default:
        return (routePost = r.R_A_DASHBOARD);
    }
  };
  const clearAlerts = () => {
    setError(null);
  };
  const postListHandler = () => {
    const url = new URL(window.location.href);
    const path = url.pathname;
    listUserFetch({
      url: a.API_USERS_REMOVE,
      method: "POST",
      data: newUsers[0].users,
      onSuccess: () =>
        history(
          getRoutePost(
            path.split("/").slice(-1)[0]
              ? path.split("/").slice(-1)[0]
              : ""
          )
        ),
    });
  };

  const setNewUsersHandler = (list: any) => {
    const newList: any = list.filter((item: any) => item.length > 0);
    const arrayNormalize: any = [];
    newList.forEach((element: any) => {
      arrayNormalize.push(element[0]);
    });
    const arraySet: any = new Set(arrayNormalize);

    if (arraySet.length == 0) {
      return;
    }
    const tempUsers = createTempModel(
      getUsersJsonPermission(),
      getUsersJsonFromListUpdated(arraySet, cSessions.company_uid)
    );

    setNewUsers(tempUsers);
    setLoading(false);
  };

  // const setNewUsersHandler = (list: any) => {
  //   const tempUsers = getUsersJsonFromList(list, cSessions.company_uid);
  //   setNewUsers(tempUsers);
  //   setLoading(false);
  // };
  const clearUsers = () => {
    setNewUsers(null);
    setcontentBottom(null);
    setConfirmTop(null);
    clearAlerts();
  };

  // confirmTop (
  //   <InputDragAndDrop
  //     danger
  //     faIcon={fa.faUserLock}
  //     onStartToDrop={clearAlerts}
  //     afterDropFile={(e: any) => {
  //       h.xlsxToObject(e, setError, setLoading, setNewUsersHandler);
  //     }}
  //   />
  // );

  useEffect(() => {
    if (_contentBottom == null) {
      setcontentBottom(
        <InputDragAndDrop
          onStartToDrop={clearAlerts}
          danger
          faIcon={fa.faUserLock}
          afterDropFile={(e: any) => {
            h.xlsxToObject(e, setError, setLoading, setNewUsersHandler);
          }}
        />
      );
    }
  }, [_contentBottom]);

  const handleDelete = (postIndex: any) => {
    const filterUser: any = newUsers[0].users
      .filter((f: any, index: any) => index !== postIndex)
      .map((item: any) => item.registry);
    filterUser.forEach((element: any, index: any) => {
      filterUser[index] = [element];
    });
    if (filterUser.length == 0) {
      clearUsers();
      return
    }
    setNewUsersHandler(filterUser);
  };

  function updateRows(newVal: any) {
    const userstoUpdate = newUsers[0];
    userstoUpdate.users.map((item: any, index: any) => {
      if (newVal[index].registry.length > 0) {
        item.registry = newVal[index].registry;
      }
    });
    setNewUsers([userstoUpdate]);
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarFilterButton />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  const configFields: any = {
    registry: {
      editable: true,
      hide: false,
    },
    status: {
      editable: false,
      hide: true,
    },
    remove: {
      editable: false,
      hide: false,
    },
  };

  useEffect(() => {
    if (listUserError) {
      // TODO show img error upload
      // console.error("listUserError", listUserError);
    } else if (isLoading || listUserIsLoading) {
      setConfirmTop(<Spinner center />);
    } else if (error) {
      setcontentBottom(
        <FriendlyInfo className={pClasses.Mt} isError text="file_not_loaded" />
      );
    } else if (newUsers) {
      // Setting confirm area
      setConfirmTop(
        <>
          <div className={pClasses.ConfirmArea}>
            <Title h2 className={pClasses.Subtitle}>
              {t(
                "global.confirm_blocking"
              )}
            </Title>
            <ButtonsArea>
              <RoundButton
                borderLess
                small
                title={"Cancelar e voltar a área de upload"}
                text={"Cancelar"}
                onClick={() => clearUsers()}
              />
              <RoundButton
                small
                title={"Confirmar sobrescrita"}
                text={"Confirmar"}
                onClick={postListHandler}
              />
            </ButtonsArea>
          </div>
          <RoundButton
            center
            // outline
            extraSmall
            aLink
            faIconL={isListOpen ? fa.faCaretDown : fa.faCaretUp}
            mb
            title={"Lista de usuários enviada"}
            text={isListOpen ? "Ocultar lista enviada" : "Exibir lista enviada"}
            onClick={() => {
              setListOpen(!isListOpen);
            }}
          />
        </>
      );
    }
  }, [listUserError, isListOpen, error, listUserIsLoading, newUsers]);

  useEffect(() => {
    if (isListOpen && newUsers) {
      setcontentBottom(
        <>
          <ListUsers
            companyUid={cSessions.company_uid}
            users={newUsers[0].users}
            hideFilter
            configFields={configFields}
            callback={updateRows}
            CustomToolbar={CustomToolbar}
            handleDelete={handleDelete}
            setHasUserChangedGroup={() => {}}
          />
        </>
      );
    }
  }, [newUsers, isListOpen]);

  let userUpdateClasses = pClasses.Users;
  if (!newUsers && !listUserError) userUpdateClasses += " " + pClasses.Center;

  return (
    <>
      <PageHeader
        title={"Bloquear Usuários"}
        subtitle={"Envie uma lista para bloquear usuários"}
        btnText={"Baixar Modelo"}
        btnTitle={"Utilizar este modelo ao subir a lista"}
        btnDownloadFile={!newUsers ? DEFAULT_MODEL_EMPLOYEE_XLSX : null}
      />
      <PageMain className={userUpdateClasses}>
        {confirmTop}
        {_contentBottom}
      </PageMain>
    </>
  );
}
